import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FormRule } from 'antd';
import { Form, Input } from 'antd';
import type { IClientUserFormFields, IClientUserFormProps } from './types';

const validationRule: Record<keyof IClientUserFormFields, FormRule[]> = {
  name: [{ required: true, type: 'string', min: 3 }],
  email: [{ required: true, type: 'email' }],
};

export const ClientUserForm: React.FC<IClientUserFormProps> = (props) => {
  const { form, formId, onFinish } = props;
  const { t } = useTranslation();

  return (
    <Form form={form} id={formId} layout='vertical' onFinish={onFinish}>
      <Form.Item name='name' label={t('common:name')} rules={validationRule.name}>
        <Input placeholder={t('common:name')} />
      </Form.Item>
      <Form.Item name='email' label={t('common:email')} rules={validationRule.email}>
        <Input placeholder={t('common:email')} />
      </Form.Item>
    </Form>
  );
};
